import { ReactPlugin } from "@microsoft/applicationinsights-react-js"
import { ApplicationInsights } from "@microsoft/applicationinsights-web"
import config from "config/config"

function initAppInsights({
    userId,
    userEmail,
    tenantName,
}: {
    userId: string
    userEmail: string
    tenantName: string
}) {
    if (!config.appInsightsKey) return

    const reactPlugin = new ReactPlugin()
    const appInsights = new ApplicationInsights({
        config: {
            instrumentationKey: config.appInsightsKey,
            maxBatchInterval: 5000,
            disableAjaxTracking: true,
            extensions: [reactPlugin],
            enableAutoRouteTracking: true
        }
    })

    appInsights.addTelemetryInitializer((item: any) => {
        if (!item.data) {
            item.data = {}
        }
        item.data.userId = userId
        item.data.userEmail = userEmail
        item.data.tenantName = tenantName
    })

    appInsights.loadAppInsights()
    appInsights.context.user.id = userId
}

export default {
    initAppInsights,
}
